import _asyncToGenerator from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-11c49692"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "emial-style"
  }, "Full name", -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "emial-style"
  }, "Credit card number", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "emial-style"
  }, "Expiry date", -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "emial-style"
  }, "Security Code", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "emial-style"
  }, "Jurisdiction", -1);
});

var _hoisted_7 = {
  class: "btn"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" Update ");

import DefaultDialog from '@/components/DefaultDialog';
import { ref, reactive, onBeforeMount, nextTick, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { apiAddUserCard } from '@/api/company-info';
import { apiCountryList } from '@/api/common';
import { updateVisible } from './data';
import Cleave from 'cleave.js';
export default /*#__PURE__*/_defineComponent({
  emits: ['getData'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var subBtnLoading = ref(false);
    var ruleFormRef = ref();
    var countryList = ref([]);
    var form = reactive({
      fullName: '',
      cardNo: '',
      expireDate: '',
      securityCode: '',
      countryCode: ''
    });
    var rulesForm = reactive({
      fullName: [{
        required: true,
        message: 'Enter a valid full name',
        trigger: ['blur', 'change']
      }],
      cardNo: [{
        required: true,
        message: 'Enter a valid card number',
        trigger: ['blur', 'change']
      }],
      expireDate: [{
        required: true,
        pattern: /^(0[1-9]|1[0-2])\/[0-9]{2}$/,
        message: 'Enter a valid expiry date',
        trigger: 'blur'
      }],
      securityCode: [{
        required: true,
        message: 'Enter a valid security code',
        trigger: ['blur', 'change']
      }],
      countryCode: [{
        required: true,
        message: 'Select a valid jurisdiction',
        trigger: ['blur', 'change']
      }] // postCode: [
      //   {
      //     required: true,
      //     message: 'Enter a valid postal code',
      //     trigger: ['blur', 'change']
      //   }
      // ]

    });
    onBeforeMount(function () {
      getCountryList();
    }); // 监听路由变化

    watch(function () {
      return updateVisible;
    }, function (newVal) {
      if (newVal.value) {
        nextTick(function () {
          // 输入正确的信用卡日期格式

          /* eslint-disable */
          new Cleave('.input-element input', {
            date: true,
            datePattern: ['m', 'y']
          });
        });
      }
    }, {
      immediate: true,
      deep: true
    }); // 提交

    function submitForm(_x) {
      return _submitForm.apply(this, arguments);
    }

    function _submitForm() {
      _submitForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formEl) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (formEl) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return formEl.validate(function (valid, fields) {
                  if (valid) {
                    // 默认包月
                    subBtnLoading.value = true;
                    apiAddUserCard(form).then(function (_ref3) {
                      var data = _ref3.data;
                      ElMessage.success('Update completed.');
                      updateVisible.value = false;
                      emit('getData');
                    }).finally(function () {
                      subBtnLoading.value = false;
                    });
                  } else {
                    console.log('error submit!', fields);
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _submitForm.apply(this, arguments);
    }

    function getCountryList() {
      apiCountryList().then(function (_ref2) {
        var data = _ref2.data;
        countryList.value = data.countryList || [];
      });
    }

    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_col = _resolveComponent("el-col");

      var _component_el_row = _resolveComponent("el-row");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createBlock(_unref(DefaultDialog), {
        modelValue: _unref(updateVisible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return _isRef(updateVisible) ? updateVisible.value = $event : null;
        }),
        width: "35%",
        "custom-class": "default-dialog no-footer-dialog login-user",
        title: "Update Payment Method"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: _unref(form),
            rules: _unref(rulesForm),
            "label-width": "0"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_row, {
                gutter: 24
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_form_item, {
                        prop: "fullName"
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_2, _createVNode(_component_el_input, {
                            maxlength: "50",
                            modelValue: _unref(form).fullName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                              return _unref(form).fullName = $event;
                            }),
                            placeholder: "Full name"
                          }, null, 8, ["modelValue"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_form_item, {
                        prop: "cardNo"
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_3, _createVNode(_component_el_input, {
                            maxlength: "50",
                            modelValue: _unref(form).cardNo,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                              return _unref(form).cardNo = $event;
                            }),
                            class: "item-input",
                            placeholder: "Credit card number"
                          }, null, 8, ["modelValue"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_row, {
                gutter: 20
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_form_item, {
                        prop: "expireDate"
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_4, _createVNode(_component_el_input, {
                            maxlength: "5",
                            modelValue: _unref(form).expireDate,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                              return _unref(form).expireDate = $event;
                            }),
                            placeholder: "Expiry date",
                            class: "item-input input-element"
                          }, null, 8, ["modelValue"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_form_item, {
                        prop: "securityCode"
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_5, _createVNode(_component_el_input, {
                            maxlength: "50",
                            modelValue: _unref(form).securityCode,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                              return _unref(form).securityCode = $event;
                            }),
                            class: "item-input",
                            placeholder: "Security Code"
                          }, null, 8, ["modelValue"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_row, {
                gutter: 20
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_form_item, {
                        prop: "countryCode"
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_6, _createVNode(_component_el_select, {
                            modelValue: _unref(form).countryCode,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                              return _unref(form).countryCode = $event;
                            }),
                            filterable: "",
                            style: {
                              "width": "100%"
                            }
                          }, {
                            default: _withCtx(function () {
                              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryList.value, function (item) {
                                return _openBlock(), _createBlock(_component_el_option, {
                                  key: item.code,
                                  label: item.description,
                                  value: item.code
                                }, null, 8, ["label", "value"]);
                              }), 128))];
                            }),
                            _: 1
                          }, 8, ["modelValue"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
                class: "project-btn",
                loading: subBtnLoading.value,
                onClick: _cache[5] || (_cache[5] = function ($event) {
                  return submitForm(ruleFormRef.value);
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_8];
                }),
                _: 1
              }, 8, ["loading"])])];
            }),
            _: 1
          }, 8, ["model", "rules"])])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});